import { playStimulusAudio } from '../../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import {
    blockScreen, unblockScreen, activateNextButton,
    greyOutScreen, colorInScreen,
} from '../../../../common/screen/screenActions';
import { narrateStart } from '../../../../common/audio/audioActions';
import selectors from '../../../../rootSelectors';
import { highlightPossibleResponse, selectPossibleResponse, resetSelectedIndex } from '../../../../common/questions/questionsActions';
import { MODEL } from '../../../../constants/assessmentItemType';
import { GENERAL_AUDIO_DELAY } from '../../../../constants/time';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';

const ACCURACY_AUDIO = RCT_AUDIO_INSTRUCTIONS.ACCURACY;

export const playModelScript = (stimulusAudio, delay) => (dispatch) => Promise.resolve()
    .then(() => dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarStartModel])))
    .then(() => dispatch(playStimulusAudio([stimulusAudio], delay)))
    .then(() => {
        dispatch(highlightPossibleResponse(0));
        return dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarAnswers[0]]));
    })
    .then(() => {
        dispatch(highlightPossibleResponse(1));
        return dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarAnswers[1]]));
    })
    .then(() => {
        dispatch(highlightPossibleResponse(2));
        return dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarAnswers[2]]));
    })
    .then(() => {
        dispatch(resetSelectedIndex());
        return dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarInstructionModel]));
    })
    .then(() => {
        dispatch(unblockScreen());
    });

export const narrateScreen = (stimulusAudio, delay = GENERAL_AUDIO_DELAY) => (dispatch) => {
    dispatch(blockScreen());
    dispatch(greyOutScreen());
    dispatch(narrateStart());
    return Promise.resolve()
        .then(() => dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarDirectionInstruction])))
        .then(() => {
            dispatch(colorInScreen());
            return dispatch(playModelScript(stimulusAudio, delay));
        });
};

export const firstIncorrectResponse = (index) => (dispatch) => {
    dispatch(selectPossibleResponse(index));
    dispatch(resetSelectedIndex());
    dispatch(unblockScreen());
};

export const nextIncorrectResponse = () => (dispatch) => {
    dispatch(activateNextButton());
    dispatch(setAvatarInstructions([ACCURACY_AUDIO.clickOk]));
    dispatch(unblockScreen());
};

export const correctResponse = (index) => (dispatch) => {
    dispatch(selectPossibleResponse(index));
    dispatch(activateNextButton());
    dispatch(setAvatarInstructions([ACCURACY_AUDIO.clickOk]));
};

export const incorrectResponseClick = (
    index,
    correctResponseIndex,
    firstAttemptResponse,
) => (dispatch) => {
    dispatch(blockScreen());
    dispatch(highlightPossibleResponse(correctResponseIndex));
    return dispatch(playAvatarAudio([ACCURACY_AUDIO.avatarInstructionModel], 0))
        .then(() => {
            if (!firstAttemptResponse) {
                dispatch(firstIncorrectResponse(index));
            } else {
                dispatch(nextIncorrectResponse());
            }
        });
};

export const modelScreenResponseClick = (index) => (dispatch, getStore) => {
    const state = getStore();
    const firstAttemptResponse = selectors.getIsFirstAttemptMade(state);
    const correctResponseIndex = selectors.getRCTAccuracyCorrectResponseIndex(state, MODEL);
    if (correctResponseIndex !== index) {
        return dispatch(incorrectResponseClick(
            index,
            correctResponseIndex,
            firstAttemptResponse,
        ));
    }
    return dispatch(correctResponse(index));
};
